import {
  createHookStore,
  createUseSelector,
  STORE_NAMES
} from '@namespace/helpers-store';
import { PromotionsState } from './types';

export const initialState: PromotionsState = {
  promotions: [],
  tournaments: [],
  bonuses: [],
  enabledPromoTypes: [],
  activeTag: 'all',
  isPromosLoaded: false,
  isTournamentsLoaded: false,
  isTournamentsLoading: false,
  isPromoBonusesLoaded: false,
  isCompleted: false
};

export const usePromotionsStore = createHookStore<PromotionsState>(
  STORE_NAMES.PROMOTIONS,
  initialState
);

export const usePromotionsSelector = createUseSelector(usePromotionsStore);
